module.exports = __webpack_public_path__ + "static/media/01-12.235d16c2.mp3";